/**
 * Map the 6 core mode percentages into readable operating dimensions.
 * Used by Deep Dive, print export, and future report PDFs.
 */
const pct = (percentages, key) => {
  const n = Number(percentages?.[key]);
  return Number.isFinite(n) ? n : 0;
};

const avgPct = (percentages, ...keys) => {
  if (!keys.length) return 0;
  const sum = keys.reduce((total, key) => total + pct(percentages, key), 0);
  return Math.round(sum / keys.length);
};

export const getProfileDimensions = (percentages = {}) => [
  {
    id: 'analytical',
    label: 'Analytical depth',
    value: avgPct(percentages, 'analyst', 'strategist'),
    modes: ['analyst', 'strategist'],
  },
  {
    id: 'creative',
    label: 'Creative vision',
    value: avgPct(percentages, 'visionary', 'innovator'),
    modes: ['visionary', 'innovator'],
  },
  {
    id: 'team',
    label: 'Team dynamics',
    value: avgPct(percentages, 'relationshipBuilder', 'visionary'),
    modes: ['relationshipBuilder', 'visionary'],
  },
  {
    id: 'execution',
    label: 'Execution power',
    value: avgPct(percentages, 'executor', 'strategist'),
    modes: ['executor', 'strategist'],
  },
];

export const getCofounderPrompts = ({ primaryType, compatibleTypes = [] }, founderTypes = {}) => {
  const primary = founderTypes[primaryType];
  const prompts = [];

  if (primary) {
    prompts.push({
      title: 'Understand your default mode',
      prompt: `When we're under pressure, I tend to lead as a ${primary.title.replace('The ', '').toLowerCase()}. Where do you feel that helps us, and where does it create friction?`,
    });
  }

  compatibleTypes.slice(0, 2).forEach((typeKey) => {
    const type = founderTypes[typeKey?.toLowerCase()];
    if (!type) return;
    prompts.push({
      title: `Learn from a ${type.title.replace('The ', '')} co-founder`,
      prompt: `You seem strong at ${type.strengths[0].toLowerCase()}. What's one decision this week where your approach would balance mine?`,
    });
  });

  prompts.push({
    title: 'Weekly alignment',
    prompt: 'What is the one outcome that would make this week a win, and what should we stop doing to protect it?',
  });

  return prompts;
};
